class AtVariantSelects extends VariantSelects {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.updateOptions();
    this.updateLabels();
  }

  connectedCallback() {
    this.syncPickerFromSelectedVariant();
  }

  /**
   * Preselects the size picker when a variant is already chosen (URL param or form input).
   */
  syncPickerFromSelectedVariant() {
    const variantId = this.getPreselectedVariantId();
    if (!variantId) return;

    const variant = this.getVariantData().find((entry) => String(entry.id) === String(variantId));
    if (!variant?.options?.length) return;

    const select = this.querySelector('select');
    if (!select) return;

    const optionValue = variant.options[0];
    const option = Array.from(select.options).find((entry) => entry.value === optionValue);
    if (!option || option.value === '-') return;

    if (select.value !== optionValue) {
      select.value = optionValue;
    }

    const customSelect = select.closest('custom-select');
    if (customSelect) {
      customSelect.updateValues(option);
      customSelect.updateStickyButton(option);
    }

    this.updateOptions();
    this.updateMasterId();
  }

  /**
   * @returns {string|null} Preselected variant id from URL or product form input.
   */
  getPreselectedVariantId() {
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) return urlVariant;

    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    return productForm?.querySelector('input[name="id"]')?.value || null;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    const sizeNotSelected = this.options.some((option) => option === '-' || option === '');

    if (sizeNotSelected || !this.currentVariant) {
      this.setAddButtonLoading(false);
      this.clearVariantInput();
      this.toggleAddButton(true, Antonioli.product.select_size);
      return;
    }

    this.setAddButtonLoading(true);
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.updateShareUrl();
  }

  clearVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) input.value = '';
    });
  }

  /**
   * Returns the main PDP add-to-cart button and its loading elements.
   * @returns {{ addButton: HTMLButtonElement, spinner: HTMLElement|null }|null}
   */
  getAddButtonElements() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = productForm?.querySelector('[name="add"]');
    if (!addButton) return null;

    return {
      addButton,
      spinner: addButton.querySelector('.loading__spinner'),
    };
  }

  /**
   * Shows or hides the loading state on the add-to-cart button while variant data is fetched.
   * @param {boolean} isLoading
   */
  setAddButtonLoading(isLoading) {
    const elements = this.getAddButtonElements();
    if (!elements) return;

    const { addButton, spinner } = elements;

    addButton.classList.toggle('loading', isLoading);
    addButton.classList.toggle('variant-loading', isLoading);
    spinner?.classList.toggle('hidden', !isLoading);
    addButton.toggleAttribute('aria-busy', isLoading);

    if (isLoading) {
      addButton.setAttribute('disabled', 'disabled');
    }
  }
  
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    this.variantsAdditionalData = JSON.parse(this.dataset.variants);
    this.productData = JSON.parse(this.dataset.product);
    this.quantityLimit = this.dataset.limit;
    this.fakeSoldout = this.dataset.fakesoldout == 'true' || false;
  }

  updateLabels() {
    const select = this.querySelector('select');
    if (!select) return;
    this.AllOptions = Array.from(select.querySelectorAll('option'));
    this.AllOptions.shift();

    this.AllOptions.forEach((element) => {

      let current = this.getVariantData().find((variant) => {
        let arr = [element.value];
          return !variant.options.map((option, index) => {
              return arr[index] === option;
          }).includes(false);
      });

      let variantData = this.variantsAdditionalData.find((variant) => {
        return current.id === variant.id;
      });

      if (this.productData.product_price_varies == true) {
        document.querySelector('input.ref1').value = variantData.variant_price
       } else {
        document.querySelector('input.ref1').value = this.productData.product_price;
       }

      if(variantData.location) {
        const location = variantData.location.toLowerCase();
        const splittedValues = location.split(",");
        let preorder = false;

        for (let singleLocation of splittedValues) {
          if (singleLocation == 'default' && variantData.qty > 0) {
            preorder = false;
            break;
          } else if (singleLocation == 'preorder' && variantData.qty > 0) {
            preorder = true;
          }
        }

        if(preorder == true) {
          element.classList.add('visible')
          element.setAttribute('data-message', 'Pre-Order')
        }
      }
      if(!element.hasAttribute('data-message')) {
        const quantity = parseInt(variantData.qty);
        

        if (quantity >0 && quantity < this.quantityLimit) {
          if (!this.fakeSoldout) {
            element.setAttribute('data-message', this.getAttribute('message-few'));
          }
        }
      }
    });
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        this.setAddButtonLoading(false);

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      })
      .catch(() => {
        if (this.currentVariant?.id !== requestedVariantId) return;

        this.setAddButtonLoading(false);
        this.toggleAddButton(true, window.variantStrings.addToCart);
      });
  }

}

customElements.define('at-variant-selects', AtVariantSelects);
